<template lang="pug">

.app-card.invoices-detail-table-panel.overflow-x-auto
  //- Leyenda de estados
  .tw-flex.tw-gap-4.tw-mb-3.tw-text-xs.tw-text-gray-600.tw-px-3.tw-pt-3(v-if='!emptyItems')
    span
      i.fa-solid.fa-circle.tw-text-orange-500.tw-mr-1
      | Pending
    span
      i.fa-solid.fa-circle.tw-text-green-500.tw-mr-1
      | Paid
    span
      i.fa-solid.fa-circle.tw-text-red-500.tw-mr-1
      | Canceled

  table(v-if='!emptyItems' class="table table-hover invoices-styled-table no-sticky-override")
    thead
      tr
        th.tw-bg-gray-50(colspan="3")
        th.tw-bg-blue-50.tw-text-center(colspan="3")
          i.fa-solid.fa-dollar-sign.tw-mr-1
          | Amounts
        th.tw-bg-green-50.tw-text-center(colspan="3")
          i.fa-solid.fa-credit-card.tw-mr-1
          | Payments
        th
      tr.tw-text-xs
        th.tw-text-gray-500 #
        th Invoice
        th Date
        //- Amounts
        th.tw-bg-blue-50.tw-border-l
          i.fa-solid.fa-receipt.tw-mr-1.tw-text-gray-400
          | Price
        th.tw-bg-blue-50.tw-text-center CC Fee
        th.tw-bg-blue-50.tw-border-r
          i.fa-solid.fa-credit-card.tw-mr-1.tw-text-gray-400
          | CC Price
        //- Payments
        th.tw-bg-green-50.tw-border-l Terms
        th.tw-bg-green-50
          i.fa-solid.fa-check-circle.tw-mr-1.tw-text-green-400
          | Paid
        th.tw-bg-green-50.tw-border-r
          i.fa-solid.fa-clock.tw-mr-1.tw-text-orange-400
          | Unpaid
        th.tw-text-center Status
        th
    tbody
      tr(v-for="(item, index) in sortedInvoices" :key="item.id" :class="getRowClass(item)")
        //- Número de secuencia
        td.tw-text-gray-400.tw-text-xs {{index + 1}}
        //- Invoice Number con link
        td
          a.tw-font-medium(:href="item.paths.show" :class="getTextClass(item)")
            i.fa-solid.fa-file-invoice.tw-mr-1.tw-text-xs
            | {{item.document_number==''? item.id : item.document_number}}
        //- Date
        td(:class="getTextClass(item)")
          span.tw-text-sm {{item.date_invoice}}
        //- Amounts section
        td.tw-bg-blue-50.tw-bg-opacity-30.tw-border-l.tw-font-medium(:class="getTextClass(item)") {{item.price}}
        td.tw-bg-blue-50.tw-bg-opacity-30.tw-text-center.tw-text-xs.tw-text-gray-500 {{item.porcent_credit_card}}
        td.tw-bg-blue-50.tw-bg-opacity-30.tw-border-r(:class="getTextClass(item)")
          span.tw-text-xs {{item.price_with_credit_card}}
        //- Payments section
        td.tw-bg-green-50.tw-bg-opacity-30.tw-border-l.tw-text-center
          span.tw-text-xs.tw-text-gray-600 {{item.cod == 0 || item.cod == 1 ? "COD" : item.cod + 'd'}}
        td.tw-bg-green-50.tw-bg-opacity-30
          span.tw-text-green-600.tw-font-medium(v-if="parseAmount(item.amount_paid) > 0")
            i.fa-solid.fa-check.tw-mr-1.tw-text-xs
            | {{item.amount_paid}}
          span.tw-text-gray-300(v-else) -
        td.tw-bg-green-50.tw-bg-opacity-30.tw-border-r
          span.tw-text-red-600.tw-font-medium(v-if="parseAmount(item.outstanding_balance) > 0")
            i.fa-solid.fa-exclamation-circle.tw-mr-1.tw-text-xs
            | {{item.outstanding_balance}}
          span.tw-text-gray-300(v-else) -
        //- Status badge
        td.tw-text-center
          span.tw-px-2.tw-py-1.tw-rounded-full.tw-text-xs.tw-font-medium(:class="getStatusBadgeClass(item)")
            i(:class="getStatusIcon(item)")
            |  {{$I18n.t('vue.states.'+item.status.toLowerCase())}}
        td
          .app-buttons-row.justify-end
            app-icon-link(
              data-kind="link",
              :href="item.paths.show"
              data-icon="fa-solid fa-eye",
              data-label="",
              :data-title="$I18n.t('vue.invoices_detail_panel.view_invoice')"
            )

  div(v-if='!emptyItems')
    .row
      .col-9
      .col-3
        .row
          table(class="table table-bordered table-hover")
            tbody
              tr
                th.d-flex(class='justify-end')  {{$I18n.t('vue.invoices_detail_panel.total_invoices')}}
                th(class="text-dark") {{calcularTotal()}}
              tr(v-if="total_amount_paid")
                th.d-flex(class='justify-end')  {{$I18n.t('vue.invoices_detail_panel.total_paid')}}
                th(class="text-success") {{total_amount_paid}}
              tr(v-if="total_amount_paid")
                th.d-flex(class='justify-end')  {{$I18n.t('vue.invoices_detail_panel.total_unpaid')}}
                th(class="text-danger")  {{total_amount_unpaid}}


  
  div
    p(v-if='emptyItems' class='message-search') {{$I18n.t('vue.invoices_detail_panel.empty_items')}}

</template>
<script>

import {BackendService} from '../../services';
import CoreComponents from "../core";
import StickyTableMixin from '../../mixins/sticky_table_mixin.js';

export default {
  mixins: [StickyTableMixin],
  components:{
    "app-icon-link": CoreComponents.AppIconLink,
  },
  props:{
    dataId: String,
    dataModel: String,
    dataOrder: String,
    dataItems: String,
    dataTotales: String,
  },
  data: function(){
    return {
      state: {
        confirmed: false,
      },
      record:{
        id: this.dataId,
        model: this.dataModel
      },
      items: JSON.parse(this.dataItems),
      total_amount_paid: (!this.dataTotales || /^\s*$/.test(this.dataTotales)) ? "" : JSON.parse(this.dataTotales).paid,
      total_amount_unpaid: (!this.dataTotales || /^\s*$/.test(this.dataTotales)) ? "" : JSON.parse(this.dataTotales).unpaid,
      data_order: JSON.parse(this.dataOrder),
      empty_item: {
        link:"",
        description:""
      }
    }
  },
  computed:{
    all_links: function(){
      var items = []
      items = this.items
      return items
    },
    sortedInvoices: function(){
      // Ordenar: primero PENDING, luego por fecha descendente
      return [...this.items].sort((a, b) => {
        // Primero las pendientes
        if (a.status === "PENDING" && b.status !== "PENDING") return -1;
        if (a.status !== "PENDING" && b.status === "PENDING") return 1;
        // Luego por fecha descendente (más recientes primero)
        const dateA = this.parseDate(a.date_invoice);
        const dateB = this.parseDate(b.date_invoice);
        return dateB - dateA;
      });
    },
    emptyItems: function(){
      return this.all_links.length === 0;
    },
  },
  methods:{
    parseDate: function(dateStr) {
      if (!dateStr) return new Date(0);
      // Formato MM/DD/YYYY
      const parts = dateStr.split('/');
      if (parts.length === 3) {
        return new Date(parts[2], parts[0] - 1, parts[1]);
      }
      return new Date(dateStr);
    },
    parseAmount: function(amountStr) {
      if (!amountStr) return 0;
      return parseFloat(amountStr.replace("$", "").replace(",", "").replace(" ", "")) || 0;
    },
    getRowClass: function(item) {
      if (item.status === "PENDING") return "tw-bg-orange-50";
      if (item.status === "CANCELED") return "tw-bg-red-50 tw-opacity-60";
      return "";
    },
    getTextClass: function(item) {
      if (item.status === "CANCELED") return "tw-text-red-400 tw-line-through";
      if (item.status === "PAID") return "tw-text-green-600";
      if (item.status === "PENDING") return "tw-text-orange-600";
      return "";
    },
    getStatusBadgeClass: function(item) {
      switch(item.status) {
        case "PENDING": return "tw-bg-orange-100 tw-text-orange-800";
        case "PAID": return "tw-bg-green-100 tw-text-green-800";
        case "CANCELED": return "tw-bg-red-100 tw-text-red-800";
        default: return "tw-bg-gray-100 tw-text-gray-800";
      }
    },
    getStatusIcon: function(item) {
      switch(item.status) {
        case "PENDING": return "fa-solid fa-clock";
        case "PAID": return "fa-solid fa-check";
        case "CANCELED": return "fa-solid fa-xmark";
        default: return "";
      }
    },
    showLink:function(path){
    },
    retrieveLinks:function(){
      let self = this; 
      BackendService
        .links(JSON.stringify({
          query:{
            linkable_type: self.record.model,
            linkable_id: self.record.id
          }
        }))
        .then((response)=>{
          self.result = response;
          if (response.isOk){
            self.items = response.links;
          }
        })
        .finally(()=>{
        })
    },
    calcularTotal:function(){
      // Usamos reduce para iterar sobre el array y sumar los precios
      let total_invoices = this.all_links.reduce((total, item) => {
        // Verificamos si el estado del elemento es diferente de "CANCELED"
        if (item.status !== "CANCELED") {
          // Si es diferente, sumamos su precio al total
          return total + parseFloat(item.price.replace("$", "").replace(",", "").replace(" ", ""));
        } else {
          // Si es "CANCELED", simplemente retornamos el total sin modificarlo
          return total;
        }
      }, 0); // Inicializamos el total en 0
      return total_invoices.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    }
  }
}
</script>

<style scoped>
.invoices-styled-table {
  font-size: 0.85rem;
  min-width: 900px; /* Ancho mínimo para evitar que se amontone */
  table-layout: auto;
}

.invoices-styled-table thead th {
  white-space: nowrap;
  vertical-align: middle;
  padding: 0.5rem 0.75rem;
}

.invoices-styled-table tbody td {
  vertical-align: middle;
  padding: 0.4rem 0.6rem;
  white-space: nowrap; /* Evitar que el texto se parta */
}

/* Bordes para separar secciones */
.tw-border-l {
  border-left: 2px solid rgba(0,0,0,0.1) !important;
}

.tw-border-r {
  border-right: 2px solid rgba(0,0,0,0.1) !important;
}

/* Fondo más sutil para las secciones */
.tw-bg-opacity-30 {
  --tw-bg-opacity: 0.3;
}
</style>
